import style from './style.module.scss';
import { useState } from 'react';

function Filter({ onClick, id, name }) {
    const [active, setActive] = useState(false);
    const handleClick = () => {
        setActive(!active);
        onClick({ active: !active, id: id });
    };
    return (
        <div className={active ? style.selected : style.unselected} onClick={handleClick}>
            {name}
        </div>
    );
}

export default Filter;
